import React, { Component } from 'react';
import axios from 'axios';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import TablePagination from '@material-ui/core/TablePagination';
import IconSearch from '@material-ui/icons/Search';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import List from './List/List';
import constants from './constants'
import Icon_drop_down from '../img/drop-down-arrow.png'
import Header from './Header'
import Util from './Util/Util'
import FlexView from 'react-flexview';
import './Util/Client';


const styles = {
    centerColumn: {
        textAlign: 'center',
    },
    progress: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlignVertical: 'center',
        marginTop: '2%',
    },
};


class Main extends Component {
    constructor(props) {
        super(props);
        this.state = {
            datas: [],
            checked_report: true,
            checked_inprogress: true,
            checked_finish: true,
            checked_irrelevant: true,
            report: "report",
            inprogress: "inprogress",
            finish: "finish",
            irrelevant: "irrelevant",
            state_all: "report,inprogress,finish,irrelevant",
            value_search: '',
            loading: true,
            limit: 5,
            page: 0,
            count: 0,
            offset: 0,
            state_serach: false,
            anchorEl: null,
            id_org: 138,
            name_org_change: "เทศบาลตำบลรัษฎา",
            list_name_org: ["เทศบาลตำบลรัษฎา", "เทศบาลนครภูเก็ต", "เทศบาลเมืองป่าตอง"],
            list_id_org: ["138", "5", "6", "140"],
            org: []
        };
    }

    handleChange = (name, field) => event => {
        this.setState({ [name]: event.target.checked });
        if (event.target.checked) {
            this.setState({ [field]: field });
        } else {
            this.setState({ [field]: "" });
        }
    };

    handleChangeOrg = event => {
        this.setState({
            id_org: event.target.value
        }, function () {
            this.Query_Data(this.state.page, this.state.limit)
        });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ limit: event.target.value })
        this.Query_Data(this.state.page, event.target.value)
    };

    handleChangePage = (event, pages) => {
        if (pages > this.state.page) {
            this.setState({ page: this.state.page + 1 });
        } else {
            this.setState({ page: this.state.page - 1 });
        }
        this.Query_Data(pages, this.state.limit)
    };

    handleClickQuery = () => {
        this.setState({
            loading: true,
        });
    };

    set_value_search = value => event => {
        this.setState({
            [value]: event.target.value,
        });
    }

    Query_Data = (pages, limit) => {
        const offset = pages * limit
        const state_all = this.state.report + ',' + this.state.inprogress
            + ',' + this.state.finish + ',' + this.state.irrelevant

        this.setState({ state_all: state_all }, function () {
            const query = ('?reported_tos='+this.state.id_org+'&limit=' + limit
                    + '&offset=' + offset + '&status=' + this.state.state_all
                    + '&search=' + this.state.value_search )

            this.setState({ loading: true, datas: [] })
            axios.get(constants.URL_FONDUE + query)
                .then(res => {
                    const data = res.data.results;
                    this.setState({ datas: data, loading: false
                        , count: res.data.count, state_serach: false });
            }).catch(error => {
                this.setState({ loading: false, });
            });
        });
    };

    Logout = () => {
        localStorage.clear()
        this.props.history.push('/login')
    }

    componentDidMount() {
        document.body.style = 'background: #EEE;';
        let token = localStorage.getItem('token')

        if (!Util.isLogin(token)) {
            this.Logout()
        } else {
            let headers = {
                headers: {
                    'content-type': 'application/json'
                    , 'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }
            axios.get('/fondue-user/org-member/', headers)
                .then(res => {
                    let data = res.data.result.filter((r) =>
                        { return r.role === 'admin' || r.role === 'staff' })

                    if (data === undefined || data.length === 0) {
                        this.Logout()
                        // let url = "https://goo.gl/forms/JBdBa7GDCAwhKQ9u2"
                        alert('คุณไม่มีสิทธ์เข้าใช้งานกรุณาติดต่อเจ้าหน้าที่ๆเกี่ยวข้อง')
                        // window.location = url;
                    } else {
                        data.map(obj => {
                            let org = {'id': obj.group.id, 'name': obj.group.name }
                            this.setState(prevState => ({
                                org: [...prevState.org, org]
                        }))});

                        this.setState({ 'id_org': this.state.org[0].id }, function() {
                            this.CallData()});
                    }
                }).catch(error => {
                    this.setState({ loading: false, });
                });
        }// Else
    }//End componentDidMount

    CallData = () => {
        // console.log(this.state.id_org)
        const query = '?reported_tos=' + this.state.id_org + '&limit=' + this.state.limit
        axios.get(constants.URL_FONDUE + query)
            .then(res => {
                const data = res.data.results;
                this.setState({ datas: data, loading: false, count: res.data.count });
            }).catch(error => {
                this.setState({ loading: false, });
            });
    }

    handleClick_state = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    render() {
        return (
            <div>
                <Header />
                <div style={{ margin: 10 }} >
                    <h1 style={{ textAlign: 'center' }}  >รายงานการแจ้งปัญหา</h1>
                    <Menu
                        id="fade-menu"
                        anchorEl={this.state.anchorEl}
                        open={Boolean(this.state.anchorEl)}
                        onClose={this.handleClose}
                        TransitionComponent={Fade}>
                        <MenuItem >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.checked_report}
                                        onChange={this.handleChange('checked_report', 'report')}
                                        value="checked_report"
                                        color="default"
                                    />
                                }
                                label="รอดำเนินการ"
                            />
                        </MenuItem>
                        <MenuItem >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.checked_inprogress}
                                        onChange={this.handleChange('checked_inprogress', 'inprogress')}
                                        value="checked_inprogress"
                                        color="primary"
                                        style={{ color: 'blue' }}
                                    />
                                }
                                label="กำลังดำเนินการ"
                            />
                        </MenuItem>
                        <MenuItem >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.checked_finish}
                                        onChange={this.handleChange('checked_finish', 'finish')}
                                        value="checked_finish"
                                        style={{ color: 'green' }}
                                    />
                                }
                                label="เสร็จสิ้น"
                            />
                        </MenuItem>
                        <MenuItem >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.irrelevant}
                                        onChange={this.handleChange('checked_irrelevant', 'irrelevant')}
                                        value="checked_irrelevant"
                                        style={{ color: 'red' }}
                                    />
                                } label="ไม่เกี่ยวข้อง" />
                        </MenuItem>
                        <MenuItem >
                            <Button variant="outlined" onClick={() => { this.Query_Data(); this.handleClose() }} >
                                ยืนยัน
                            </Button>
                        </MenuItem>
                    </Menu>

                    <Paper  style={{ borderRadius: 10, padding: 10 }}>
                        <FlexView style={{ flex: 1 }} hAlignContent='center'>
                            <TextField
                                    style={{ width: '95%' }}
                                    id="with-placeholder"
                                    label="ค้นหา..."
                                    placeholder="ชื่อผู้แจ้ง , ตำแหน่งปัญหา , รายละเอียดการแจ้ง"
                                    value={this.state.age}
                                    onChange={this.set_value_search('value_search')} />
                                <FlexView vAlignContent='bottom'>
                                    <a href="#" style={{ color: "#0000008a", paddingLeft: 10 }} >
                                        <IconSearch  onClick={() => this.Query_Data() }  />
                                    </a>
                                </FlexView>
                        </FlexView>
                    </Paper>

                    <FormControl style={{ marginTop: 15, marginLeft: 15 }}>
                        <Select
                            value={this.state.id_org}
                            onChange={this.handleChangeOrg}>
                            {this.state.org.map(obj =>
                                <MenuItem value={obj.id} key={obj.id}>{obj.name}</MenuItem>
                            )}

                        </Select>
                    </FormControl>
                    <Paper  style={{ borderRadius: 10, padding: 10, marginTop: 15 }}>
                        <div style={{ overflowX: 'auto' }}>
                            <Table>
                                <TableHead>
                                    <TableRow style={styles.centerColumn}>
                                        <TableCell>วัน/เดือน/ปี</TableCell>
                                        <TableCell numeric style={styles.centerColumn}>รูปก่อนแก้ไข</TableCell>
                                        <TableCell numeric style={styles.centerColumn}>รูปหลังแก้ไข</TableCell>
                                        <TableCell numeric style={styles.centerColumn}>หมวดหมู่</TableCell>
                                        <TableCell numeric style={styles.centerColumn}>รายละเอียด</TableCell>
                                        <TableCell numeric style={styles.centerColumn}>ตำแหน่ง</TableCell>
                                        <TableCell numeric style={styles.centerColumn} onClick={this.handleClick_state} href="#" >
                                            <a href="#" style={{ color: "#0000008a" }}>สถานะ
                                                <img href="#" src={Icon_drop_down} style={{ width: 10, height: 10 }} />
                                            </a>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody >
                                    {this.state.datas.map(obj =>
                                        <List key={obj.id} result={obj} />
                                    )}
                                </TableBody>
                            </Table>
                            <div style={styles.progress}>
                                <Fade
                                    color="inherit"
                                    in={this.state.loading}
                                    unmountOnExit>
                                    <CircularProgress />
                                </Fade>
                            </div>
                            <TablePagination
                                component="div"
                                count={this.state.count}
                                rowsPerPage={this.state.limit}
                                page={this.state.page}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage} />
                        </div>
                    </Paper>
                </div>
            </div>
        );
    }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/Main.js